var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4768 12.8906L16.9918 21.4166C17.0087 21.517 16.9946 21.6202 16.9514 21.7124C16.9081 21.8046 16.8377 21.8813 16.7497 21.9324C16.6616 21.9835 16.56 22.0065 16.4586 21.9983C16.3571 21.9902 16.2605 21.9512 16.1818 21.8866L12.6018 19.1996C12.4289 19.0705 12.219 19.0007 12.0033 19.0007C11.7875 19.0007 11.5776 19.0705 11.4048 19.1996L7.81875 21.8856C7.74007 21.9501 7.64361 21.989 7.54225 21.9972C7.44088 22.0054 7.33942 21.9825 7.25141 21.9315C7.16341 21.8805 7.09303 21.804 7.04967 21.712C7.00631 21.62 6.99204 21.5169 7.00875 21.4166L8.52275 12.8906",
    stroke: "#026825",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14Z",
    stroke: "#026825",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalSimple);
export default __webpack_public_path__ + "static/media/medal-simple.1bb7d83b894b8c7edc0f25bc27bddc27.svg";
export { ForwardRef as ReactComponent };